import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Signale une visite au backend (best-effort). Le backend deduplique par IP et par jour :
// un rafraichissement (F5) le meme jour ne recompte pas le visiteur.
export const trackVisit = () =>
  axios.post(`${API_BASE_URL}/track/visit`, {}).catch(() => {});

// Langue recommandee selon le pays de l'IP ("fr" pour un pays francophone, sinon "en").
export const getGeoLocale = () => axios.get(`${API_BASE_URL}/track/locale`);
